import { InvoiceDto } from "@/types/api/api-types";

export type InvoiceTableState = {
  filters: {
    searchField: string;
    statusField: string;
    ribId: string | undefined;
    year: number | undefined;
    month: number[] | undefined;
    amountToBill: (number | undefined)[];
  };
  modals: {
    invoiceDeleteModal: string | null;
    selectedInvoice: InvoiceDto | null;
    invoiceToEdit: InvoiceDto | null;
    statusEditInvoice: InvoiceDto | null;
    displayStats: boolean;
    displayDownloadPdf: boolean;
  };
};

export type InvoiceTableAction =
  | {
      type: "SET_FILTER";
      field: keyof InvoiceTableState["filters"];
      value: any;
    }
  | { type: "SET_MODAL"; field: keyof InvoiceTableState["modals"]; value: any }
  | { type: "RESET_FILTERS" }
  | { type: "CLOSE_ALL_MODALS" };

export const initialState: InvoiceTableState = {
  filters: {
    searchField: "",
    statusField: "",
    ribId: undefined,
    year: new Date().getMonth() === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear(),
    month: [new Date().getMonth() === 0 ? 11 : new Date().getMonth() - 1],
    amountToBill: [undefined, undefined],
  },
  modals: {
    invoiceDeleteModal: null,
    selectedInvoice: null,
    invoiceToEdit: null,
    statusEditInvoice: null,
    displayStats: false,
    displayDownloadPdf: false,
  },
};

export function invoiceTableReducer(
  state: InvoiceTableState,
  action: InvoiceTableAction,
): InvoiceTableState {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.field]: action.value,
        },
      };
    case "SET_MODAL":
      return {
        ...state,
        modals: {
          ...state.modals,
          [action.field]: action.value,
        },
      };
    case "RESET_FILTERS":
      return {
        ...state,
        filters: initialState.filters,
      };
    case "CLOSE_ALL_MODALS":
      return {
        ...state,
        modals: initialState.modals,
      };
    default:
      return state;
  }
}

export const createFilterAction = (
  field: keyof InvoiceTableState["filters"],
  value: any,
): InvoiceTableAction => ({
  type: "SET_FILTER",
  field,
  value,
});

export const createModalAction = (
  field: keyof InvoiceTableState["modals"],
  value: any,
): InvoiceTableAction => ({
  type: "SET_MODAL",
  field,
  value,
});
